/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */

// Importi come stringhe decimali "1234.56" dal server, mai float per i totali.
export function formatEuro(decimal: string | null): string {
  if (decimal === null) return '—';
  const [int, frac = '00'] = decimal.split('.');
  const withDots = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${withDots},${frac.padEnd(2, '0')} €`;
}

export function formatKm(decimal: string): string {
  return `${decimal.replace('.', ',')} km`;
}

// "12,5" o "12.50" -> "12.50"; null se non è un importo valido.
export function normalizeAmount(input: string): string | null {
  const s = input.trim().replace(',', '.');
  if (!/^\d{1,8}(\.\d{1,2})?$/.test(s)) return null;
  const [int, frac = ''] = s.split('.');
  return `${int}.${frac.padEnd(2, '0')}`;
}

// Km in decimi interi, come li conta il server: 473 -> "47.3".
export function tenthsToDecimal(tenths: number): string {
  return `${Math.floor(tenths / 10)}.${tenths % 10}`;
}

// "94.6" -> 946 senza passare da un float; null se non è un numero di km.
export function decimalToTenths(decimal: string): number | null {
  const match = /^(\d+)(?:\.(\d)\d*)?$/.exec(decimal);
  if (!match) return null;
  return parseInt(match[1], 10) * 10 + parseInt(match[2] || '0', 10);
}
